<template>
<v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title pa-0 primary-title class="grey lighten-4">
                <v-tooltip top>
                    <v-btn
                    slot="activator"
                    dark
                    @click.stop="helpdialog = true"
                    icon class="mx-0">
                    <v-icon color="red">help</v-icon>
                    </v-btn>
                    <span>Atención técnica</span>
                </v-tooltip>
                <h3 class="headline mb-0">Respaldo de Actuaciones</h3>
            </v-card-title>
              <!-- Inicio de las tarjetas -->
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 lg6>
                            <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="computedDateFormattedFecha"
                                        label="Fecha"
                                        persistent-hint
                                        prepend-icon="event"
                                        v-on="on"
                                        :rules="[v => !!v || 'Fecha desde es requerido']"
                                        required
                                    ></v-text-field>
                                </template>
                                <v-date-picker :max="new Date().toISOString().slice(0,10)" v-model="form.f_desde" no-title @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <!-- <v-flex xs12 lg6>
                            <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="computedDateFormattedFecha2"
                                        label="Fecha Hasta"
                                        persistent-hint
                                        prepend-icon="event"
                                        v-on="on"
                                        :rules="[v => !!v || 'Fecha hasta es requerido']"
                                        required
                                    ></v-text-field>
                                </template>
                                <v-date-picker :min="form.f_desde" :max="new Date().toISOString().slice(0,10)" v-model="form.f_hasta" no-title @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-flex> -->
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="primary darken-1" @click="submitForm">Generar</v-btn>
            </v-card-actions>
        </v-form>
        </v-card>
    </v-flex>

    <!-- Inicio de dialogo de ayuda -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Archivo de actuaciones diarias</v-card-title>

            <v-card-text>
              <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
              <h3>Sección para generar el archivo en EXCEL con todas las actuaciones por día.</h3>
              </v-flex>
              <v-flex xs6>
              Según especificaciones del sistema INT, es un archivo.xlsx con los siguientes campos:
              <ul>
                <li>ID</li>
                <li>FECHA</li>
                <li>CPC</li>
                <li>PERSONA</li>
                <li>PAPEL</li>
                <li>RAP</li>
                <li>USO</li>
                <li>GG</li>
                <li>IVA</li>
                <li>IVAP</li>
                <li>MONTO</li>
                <li>RAZON</li>
                <li>RIF</li>
              </ul>
              </v-flex>
              <v-flex xs6>
                <p>El archivo.xlsx podrá ser descargado por el analista AUTORIZADO y colocado estratégicamente en una ruta del servidor para que el Sistema INT pueda montarlo mediante un proceso de subida de información.</p>
                <br>
                <p></p>
              </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->
  </v-layout>
</template>

<script>
import Form from 'vform'
import axios from 'axios'

  export default {

    data: () => ({
        date: '',
        // date2: '',
        dateFormatted: '',
        // dateFormatted2: '',
        valid: false,
        loading: false,
        helpdialog: false,
        menu1: false,
        // menu2: false,
        form: new Form({
            f_desde: '',
            // f_hasta: '',
        })
    }),

    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.f_desde)
        },
        // computedDateFormattedFecha2 () {
        //     return this.formatDate(this.form.f_hasta)
        // },
    },

    methods: {

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async submitForm() {
            if (this.$refs.form.validate()) {
                this.loading = true
                await axios({
                    url: `/api/admin/backup/${this.form.f_desde}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'RAP.xlsx';
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, intente mas tarde'
                    })
                })
                .finally(() => this.loading = false);
            }
        }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/backup.vue